<template>
  <div>
    <div class="mb-3">
      <label v-if="label" class="form-label fw-semibold">
        {{ label }} <span v-if="required" class="text-danger">*</span>
      </label>
      <div class="input-group input-group-lg">
        <span class="input-group-text">
          <i class="fas fa-search"></i>
        </span>
        <input 
          ref="scannerInput"
          type="text" 
          class="form-control" 
          v-model="codigoBarras"
          @keyup.enter="buscarProducto"
          :placeholder="placeholder"
          :disabled="disabled || !!value" :autofocus="autofocus"
        />
        <button 
          class="btn btn-primary" 
          @click="buscarProducto"
          :disabled="!codigoBarras || disabled || !!value" >
          Buscar
        </button>
        <button 
          v-if="allowClear && value"
          class="btn btn-outline-danger" 
          @click="limpiarProducto"
          title="Cambiar producto"
        >
        <i class="fas fa-trash"></i>
        </button>
      </div>
      <small v-if="helpText" class="text-muted d-block mt-2">
        {{ helpText }}
      </small>
    </div>
  </div>
</template>

<script>
import ProductosService from '@/services/catalogos/ProductosService';

export default {
  name: 'ProductScanner',
  
  props: {
    // ... Tus otras props
    label: { type: String, default: 'Producto' },
    required: { type: Boolean, default: true },
    placeholder: { type: String, default: 'Escanee o escriba el SKU del producto...' },
    helpText: { type: String, default: 'Escanee el código de barras del producto' },
    allowClear: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    autofocus: { type: Boolean, default: true },
    apiEndpoint: { type: String, default: '/productos' },
    
    // Valor inicial/actual (gestiona el estado del producto desde el padre via v-model)
    value: {
      type: Object,
      default: null
    }
  },
  
  data() {
    return {
      codigoBarras: '',
      // Eliminamos productoEncontrado: null,
      buscando: false
    };
  },
  
  watch: {
    // Si se pasa un valor inicial o cambia el producto desde el padre, actualiza el código de barras
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue && newValue.sku) {
          this.codigoBarras = newValue.sku;
        } else if (!newValue) {
          // Opcional: limpiar codigoBarras si el padre lo ha puesto a null
          this.codigoBarras = '';
        }
      }
    }
  },
  
  methods: {
    async buscarProducto() {
      if (!this.codigoBarras.trim() || this.buscando) {
        this.$emit('error', 'Por favor ingrese un código de barras');
        return;
      }

      this.buscando = true;

      // Llamada real a la API
      
      ProductosService.getById(
        this.codigoBarras
      ).then(response => {
        // Emitir el producto encontrado al componente padre
        this.$emit('producto-encontrado', response.data);
        this.$emit('input', response.data); // Para que el padre actualice su v-model
      })
      .catch(error => {
        console.log(error.response.data);
        let err = error.response ? this.formatearMsg(error.response.data): "No se encontró el producto";
        this.mostrarError(`${err}: ${this.codigoBarras}`);
        this.$emit('input', null); // Asegurar que el v-model del padre es null en caso de error
      })
      .finally(() => {
        this.buscando = false;
      });
    },
    
    mostrarError(mensaje) {
      // Ya no modificamos productoEncontrado
      // Emitir error al padre
      this.$emit('error', mensaje);
      // No emitimos input: null aquí porque si se encontró un producto antes, no queremos limpiarlo automáticamente
      // si un nuevo escaneo falla, pero si lo hace buscarProducto().catch
    },
    formatearMsg(data) {
      let mensajeCompleto = "";

      // 1. Obtener las claves (nombres de los campos) del objeto del mensaje
      const campos = Object.keys(data);
      campos.forEach(campo => {
        // 2. Obtener la lista de mensajes para ese campo
        const datosDelCampo = data[campo];
        // 3. Formatear el nombre del campo para que sea más legible (opcional)
        // Ejemplo: 'producto' -> 'Producto'
        const nombreCampoFormateado = campo.charAt(0).toUpperCase() + campo.slice(1).replace(/_/g, ' ');

        // 4. Iterar sobre la lista de mensajes
        // Construir el mensaje final: "Campo: Mensaje "
        mensajeCompleto += `${nombreCampoFormateado}: ${datosDelCampo}\n`;

      });

      // Si no se encontraron errores específicos de campos, usar un mensaje genérico
      if (mensajeCompleto === "" && typeof data === 'string') {
        return data;
      } else if (mensajeCompleto === "") {
        return "Ha ocurrido un error desconocido al procesar la solicitud.";
      }

      return mensajeCompleto.trim();
    },
    limpiarProducto() {
      // Ya no modificamos productoEncontrado
      this.codigoBarras = '';
      
      // Emitir limpieza al padre
      this.$emit('producto-limpiado');
      this.$emit('input', null); // Limpiar el v-model del padre
      
      // Devolver el foco al input
      this.$nextTick(() => {
        this.$refs.scannerInput.focus();
      });
    },
    
    // Método público para limpiar desde el padre
    clear() {
      this.limpiarProducto();
    },
    
    // Método público para hacer foco desde el padre
    focus() {
      this.$nextTick(() => {
        this.$refs.scannerInput.focus();
      });
    }
  }
};
</script>

<style scoped>
.input-group-lg .input-group-text {
  font-size: 1.5rem;
}

.alert {
  border-radius: 0.5rem;
}
</style>